import mongoose, { Schema } from 'mongoose';
import {
  always,
  applySpec,
  compose,
  converge,
  nthArg,
  propOr,
} from 'ramda';
import { string } from '@555platform/utility-belt.js';
import { renameObjectKeys } from '../util';
import { query as queryModel } from './util';

const apnAuthTokenSchema = new Schema({
  className: { type: String },
  readAccess: [String],
  writeAccess: [String],
  ownerID: { type: String },
  createAt: { type: Date },
  updatedAt: { type: Date },
  fields: {
    app_key: { type: String },
    app_domain_client_id: { type: String },
    app_domain: { type: String },
    apns_team_id: { type: String },
    apns_key_id: { type: String },
    apns_priv_key: { type: String },
    apns_production: { type: String },
  },
});

const applyFieldScope = string.createTemplate('fields.${}');

export const apnAuthTokenModel = () => mongoose.model(
  'apnAuthTokeninfo',
  apnAuthTokenSchema,
  'ApnAuthTokenInfo',
);

export const query = queryModel(apnAuthTokenModel);

apnAuthTokenSchema.statics.findByAppKey = compose(
  query('findOne'),
  applySpec({
    'fields.app_key': nthArg(0),
    ownerID: nthArg(1),
  }),
);

// apnAuthTokenSchema.findByAppKey = (app_domain_client_id) => {
//    const apnAuthToken = apnAuthTokenModel();
//    return apnAuthToken.findOne({'fields: app_key' : app_key});
// };

const now = () => new Date();

apnAuthTokenSchema.statics.upsert = converge(query('findOneAndUpdate'), [
  applySpec({ 'fields: app_key': propOr('__', 'app_key') }),
  applySpec({
    updatedAt: now,
    $setOnInsert: { ownerID: nthArg(1), createdAt: now },
    $set: renameObjectKeys(applyFieldScope),
  }),
  always({
    upsert: true,
    setDefaultsOnInsert: true,
    new: true,
  }),
]);

export default apnAuthTokenModel;
